import { UIGameExpandContractAnimation } from './../../ui_canvas_engine/animation/UIGameExpandContractAnimation.ts';
import { SpriteView } from '../../ui_canvas_engine/SpriteView.ts';
import { UIGameMapDiceHighlightView } from './UIGameMapDiceHighlightView.ts';
import { Point } from '@colonist/game-mechanic-validators';
import { SectionView } from '../../ui_canvas_engine/SectionView.ts';
export class UIGameMapDiceProbabilityView extends SectionView {
    animate() {
        if (this.animation.isAnimationInProgress) return;
        this.animation.start();
    }
    resetAnimation() {
        this.animation.stop();
    }
    highlight() {
        this.highlightDiceView.show();
    }
    removeHighlight() {
        this.highlightDiceView.hide();
    }
    constructor(x, y, w, h, hexFace, container, texture){
        super(x, y, w, h, container, false);
        this.size = w;
        this.center = new Point(x + this.size / 2, y + this.size / 2);
        new SpriteView(0, 0, this.width, this.height, this, texture);
        const highlightDiceX = -this.width * 0.01;
        const highlightDiceY = -this.height * 0.01;
        const highlightDiceW = w * 0.96;
        this.highlightDiceView = new UIGameMapDiceHighlightView(highlightDiceX, highlightDiceY, highlightDiceW, this);
        this.highlightDiceView.hide();
        this.hexFace = hexFace;
        this.animation = new UIGameExpandContractAnimation(this);
    }
}
